<!--
================================================
Vue affichant les rapports d'activité
================================================

LIMITATIONS :

    * Le rapport pdf généré depuis mobile est trop petit
    * Le rapport pdf n'est pas dispo pour la detailed view
    * Les périodes this/lastYear affichent 365 barres dans le chart
    * Le composant utilise encore l'ancienne propriété periodName définie à "custom" en dur mais @since 0.39.0 il n'y a plus qu'une période custom @todo il faudra refactorer periodName https://gitlab.com/ousmane1/kronocloud/-/issues/558

    voir : https://gitlab.com/ousmane1/kronocloud/-/milestones/23

NOTES :
 - le fonctionnement les param de route startDate et endDate déclenche le loading des tr
 -  si startDate et endDate sont vides ils sont auto générés grâce à la méthode completeRoute
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <app-layout-comp>
        <div slot="AppContent" id="ReportsView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
            <!--<component></component>-->
<!--            <div class="columns">-->
<!--                <div class="column">-->

<!--                    &lt;!&ndash; titre de la page -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--                    <div class="has-text-left appTitle">-->
<!--                        <h3 class=""><font-awesome-icon class="icon" :icon="['far', 'folder-open']" />-->

<!--                            {{$t('rapports')}}-->
<!--                        </h3>-->
<!--                        <p class="appSubTitle">{{$t('LesRapportsVousPermettent')}}</p>-->
<!--                    </div>-->


<!--                </div>-->
<!--            </div>-->

            <!---TABS + BTNS ----------------------------->
            <div class="columns is-mobilePaused headerZone mt-2 px-2">
                <div class="column is-narrow ">
                  <period-selector-custom-comp></period-selector-custom-comp>

                </div>

                <!-- btns--------------------->
                <div class="column columnTypeSelector columnBtnPAUSED  ">
                  <report-type-selector-comp></report-type-selector-comp>

                </div>
            </div>

            <!-----------ZONE FILTER----------------------->
            <div class="filterZone ">
                <div class="columns is-desktop">

                    <div class="column">
                        <filters-comp></filters-comp>
                    </div>
                </div>

            </div>

            <div id="summaryReportContainer"  v-show="reportType=='summary'" >

              <div class="columns">
                <div class="column">

                  <div ref="summaryReport2Print">

                    <!-----------PERIOD DURATION----------------------->

                    <div class="is-flex is-justify-content-space-between is-align-items-center mt-3" >

                        <period-duration-comp
                            v-bind:timerecordsOfPeriod="timerecordsOfPeriodFiltered[periodName]">
                        </period-duration-comp>

                        <a
                            tabindex="0"
                            v-show="reportType=='summary'"
                            v-bind:title="$t('télécharger')"
                            class="call2ActionBtn button has-text-white is-primary " id="DownloadReportBtn"
                            v-on:click="generatePdf()">
                          <font-awesome-icon :icon="['fas', 'save']" class="icon"/>
                          <span class="is-hidden-touch">{{ $t("télécharger") }}</span>
                        </a>
                    </div>

                    <!-----------CHART ----------------------->
                    <div class="summaryView">
                      <div class="chartZone">
                        <br>
                        <bar-chart-comp
                            v-bind:periodStartDate="periodStartDate"
                            v-bind:periodEndDate="periodEndDate"
                            v-bind:timerecordsOfPeriod="timerecordsOfPeriodFiltered[periodName]"></bar-chart-comp>

                        <br>
                      </div>
                    </div>

                  </div>

                  <!-- ⚠️⚠️⚠️ hiddenChartData sert à 2 choses :
  * permettre de tester les datas du chart via cypress
  * aussi étrange que cela parait si je n'affiche pas timerecordsOfPeriod dans la vue, le chart est toujours vide au chargement initial !!! 😐 -->
                  <div id="hiddenChartData" style="display:none;">
                    <div v-for="(trGroupDayDate,key) in timerecordsOfPeriod[periodName]" class="groupDay" :id="'group_'+key">
                      <div class="date">{{key}}</div>
                      <div v-for="tr in trGroupDayDate" class="trDetails" :key="tr.slug" :id="'tr_'+tr.slug">
                        <span class="taskName">{{ tr.taskName }}</span>
                        <span class="duration">{{ tr.duration }}</span> |
                        <span class="slug">{{ tr.slug }}</span> |
                      </div>
                    </div>

                  </div>
                  <!--️⚠️⚠️⚠️-->


                  <workspace-tr-summary-comp v-bind:timerecords="timerecordsOfPeriodFiltered[periodName]"></workspace-tr-summary-comp>
                </div>
              </div>
            </div>

          <!-- ########################################## -->

          <div id="detailedReportContainer" ref="detailedReport2Print" v-show="reportType=='detailed'" class="mt-4" >

                <!-----------PERIOD DURATION----------------------->
                    <period-duration-comp
                            v-bind:periodName="periodName" v-bind:timerecordsOfPeriod="timerecordsOfPeriodFiltered[periodName]">

                    </period-duration-comp>


                <!-----------DETAILES TR LIST----------------------->
                <div class="detailedView">
                    <timerecords-detailed-list-comp v-bind:timerecordsOfPeriod="timerecordsOfPeriodFiltered[periodName]"></timerecords-detailed-list-comp>
                </div>

            </div>


        </div>
    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    import ReportTypeSelectorComp from '@/components/Reports/ReportTypeSelectorComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import TrackingMixin from "../mixins/TrackingMixin.js";
    import GlobalErrorNotificationMixin from "../mixins/GlobalErrorNotificationMixin.js";

    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
    import PeriodSelectorComp from "@/components/Reports/PeriodSelectorComp";
    import BarChartComp from "@/components/Reports/BarChartComp";

    import {mapState} from 'vuex'
    import FiltersComp from "../components/Reports/FiltersComp";
    import TimerecordsDetailedListComp from "../components/Reports/TimerecordsDetailedListComp";
    import _ from "lodash";
    import PeriodDurationComp from "../components/Reports/PeriodDurationComp";
    import PeriodSelectorCustomComp from "@/components/Reports/PeriodSelectorCustomComp";
    import TaskTimerecordListComp from "@/components/TaskTimerecordListComp";
    import WorkspaceTrSummaryComp from "@/components/Reports/WorkspaceTrSummaryComp";

    export default {
        name: 'ReportsView',
        components: {
          WorkspaceTrSummaryComp,
          TaskTimerecordListComp,
          PeriodSelectorCustomComp,
            PeriodDurationComp,
            TimerecordsDetailedListComp,
            FiltersComp,
            AppLayoutComp,SpinnerLoaderComp,ReportTypeSelectorComp,PeriodSelectorComp,BarChartComp
            // Component,
        },
        mixins: [VueMetaMixin, SentryMixin, InterceptorMixin, GlobalErrorNotificationMixin, TrackingMixin],


        data: function () {
            return {
                // locale : this.$route.params.locale
                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // componentIsReady : false, // indique quand le composant est prêt à être afficher


                timerecordsOfPeriod : { // les timerecords pour les périodes (récupérés depuis api rest)
                  //@todo Supprimer les periodes @deprecated (@since 0.39.0 il n'y a plus qu'une période custom) https://gitlab.com/ousmane1/kronocloud/-/issues/558
                    // today: null,  // @deprecated
                    // yesterday: null, // @deprecated
                    // thisWeek: null, // @deprecated
                    // lastWeek: null, // @deprecated
                    // thisMonth: null, // @deprecated
                    // lastMonth: null, // @deprecated
                    // thisYear:null, // @deprecated
                    // lastYear: null, // @deprecated
                    custom:null
                },

                timerecordsOfPeriodFiltered:{}, // copie filtrée de timerecordsOfPeriod

                // =================================================================
            }
        },
        computed:{
            // computed props for store :
            ...mapState({
                currentPeriod: state => state.ReportView.currentPeriod,
                // filterRules: state => state.ReportView.filterRules,
                filterRulesProject: state => state.ReportView.filterRules.project, // note : j'ai crée cette seconde computed prop car je ne parvenais pas à watcher sur filterRules
                filterRulesTag: state => state.ReportView.filterRules.tag, // note : j'ai crée cette seconde computed prop car je ne parvenais pas à watcher sur filterRules
                filterRulesClient: state => state.ReportView.filterRules.client, // note : j'ai crée cette seconde computed prop car je ne parvenais pas à watcher sur filterRules
                filterRulesBillable: state => state.ReportView.filterRules.billable,
                filterRulesTaskName: state => state.ReportView.filterRules.taskName,
                themeToDisplay: state=> state.app.themeToDisplay
            }),

            //----------------------------------------------
            // other computed props :
            periodName: { // le nom de la période
                get: function () {return 'custom'}, //@todo à refactorer ? @since 0.39.0 il n'y a plus qu'une seule période custom | https://gitlab.com/ousmane1/kronocloud/-/issues/558
            },
            reportType: { // ( :reportType(summary|detailed) récupérée dans la route)
                get: function () {return this.$route.params.reportType},
            },
            isDevEnv: {
                get: function () {
                  if (process.env.NODE_ENV=='development') {return true}
                },
            },

            // retourne la date de début de la période au format yyyy-mm-dd
            periodStartDate: {
              get: function () {return this.$route.params.startDate},
            },
            // retourne la date de fin de la période au format yyyy-mm-dd
            periodEndDate: {
              get: function () {return this.$route.params.endDate},

            }
        },
        watch: {

            // Quand les dates de début/fin change on recharge les pointages
          periodStartDate:function () {
                    this.getPeriodTimerecords()
            },
          // Quand les dates de début/fin change on recharge les pointages
          periodEndDate:function () {
                this.getPeriodTimerecords()
            },

            // quand les critères des filtres changent, on relance le filtrage
            filterRulesProject: function () {
                this.filterTimerecords()
            },
            // quand les critères des filtres changent, on relance le filtrage
            filterRulesTag: function () {
                this.filterTimerecords()
            },
            // quand les critères des filtres changent, on relance le filtrage
            filterRulesClient: function () {
                this.filterTimerecords()
            },
            // quand les critères des filtres changent, on relance le filtrage
            filterRulesBillable: function () {
                this.filterTimerecords()
            },
            // quand les critères des filtres changent, on relance le filtrage
            filterRulesTaskName: function () {
                this.filterTimerecords()
            }

        },

        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleReportsView"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {

            /**
             * Récupère les timerecords pour la période
             */
            getPeriodTimerecords(){
              const params = {
                type: 'taskOnly',
                startDate: this.$route.params.startDate,
                endDate: this.$route.params.endDate,
                scope: null
              }

              if(this.$auth.hasRole('ROLE_ADMIN')){
                params.scope= 'wsp'
              }
                let self = this;
                self.$root.$emit('report_view_fetching_data',true)
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/timeRecordsMetrics/timerecordsByPeriodCustom`,
                    {
                        params,
                        headers: {Authorization: self.$auth.header()},
                        timeout: 20000 // surcharge timeout car la récupération a tendance à prendre du temps @todo à améliorer à terme ?
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur


                      self.timerecordsOfPeriod[self.periodName] = response.data; // ex :timerecordsOfPeriod.thisWeek //
                        // filtrage initial (si le filtre est actif)
                        self.initFilterRules()
                        self.filterTimerecords()
                        self.$root.$emit('report_view_tr_loaded')
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0035'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching timerecords"})
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching timerecords', 'fatal': false})
                            self.$sentry.captureMessage(`Error ${errorCode} > "error fetching timerecords in TimerecordsActivityChartsComp : ${error}`, 'error')
                        }
                    }).then(() => {
                        // toujours exécuté
                        self.$root.$emit('report_view_fetching_data', false)
                    })
            }

            /*
             Retourne true si le filtre projet a au moins un critère de tri activé.
            */
            ,filterProjectIsActive(){
                if(this.filterRulesProject.noRelated ==  true
                    || this.filterRulesProject.projects2Filter.length > 0
                ){
                    return true
                }
            }

            /*
             Retourne true si le filtre tag a au moins un critère de tri activé.
            */
            ,filterTagIsActive(){
                if(this.filterRulesTag.noRelated ==  true
                    || this.filterRulesTag.tags2Filter.length > 0
                ){
                    return true
                }
            }


            /*
             Retourne true si le filtre client a au moins un critère de tri activé.
            */
            ,filterClientIsActive(){
                if(this.filterRulesClient.noRelated ==  true
                    || this.filterRulesClient.clients2Filter.length > 0
                ){
                    return true
                }
            }

            /*
             Retourne true si le filtre billable a au moins un critère de tri activé.
            */
            ,filterBillableIsActive(){
                if(this.filterRulesBillable.billableFilter ==  true
                    || this.filterRulesBillable.nonBillableFilter == true
                ) {
                  return true
                }
          },

          /*
           Retourne true si le filtre taskName a au moins un critère de tri activé.
          */
          filterTaskNameIsActive() {
            if (this.filterRulesTaskName.noRelated == true) {
              return true
            } else if (!_.isEmpty(this.filterRulesTaskName.description)) {
              return true
            }
          },

            /*
            Retourne true si le timerecord passé en paramètre satisfait les critères du filtre client
            */
            trMatchClientFilter(tr) {

                if (this.filterClientIsActive()) {

                    // filtrage tr sans client,
                    if (this.filterRulesClient.noRelated === true) {
                        if (tr.project == null || tr.project.client == undefined) {
                            return true
                        }
                    }

                    // filtrage clients spécifiques (ATTENTION : projet null, client est null)
                    if (tr.project != null && tr.project.client != null && this.filterRulesClient.clients2Filter.includes(tr.project.client.slug)) {
                        return true

                    }
                }else{
                    return true // si le filtre n'est pas actif alors on considère que le tr match le filtre
                }
            },


            /*
            Retourne true si le timerecord passé en paramètre satisfait les critères du filtre projet
            */
            trMatchProjectFilter(tr){

                if (this.filterProjectIsActive()) {
                    // filtrage tr sans projet,
                    if (this.filterRulesProject.noRelated === true) {
                        if (tr.project == null ) {
                            return true
                        }
                    }

                    // filtrage projet spécifique
                    if (tr.project != null && this.filterRulesProject.projects2Filter.includes(tr.project.slug)) {
                        return true

                    }
                }
                else{
                    return true // si le filtre n'est pas actif alors on considère que le tr match le filtre
                }

            },

            /*
            Retourne true si le timerecord passé en paramètre satisfait les critères du filtre tag
            */
            trMatchTagFilter(tr){

              if (this.filterTagIsActive()) {
                // filtrage tr sans tag,
                if (this.filterRulesTag.noRelated === true) {
                  if (tr.tag == null ) {
                    return true
                  }
                }

                // filtrage par tags spécifiques
                // console.debug(this.filterRulesTag.tags2Filter)
                // .. si au moins 1 des tags du tr est présent dans this.filterRulesTag.tags2Filter, alors on sélectrionne le tr

                if (tr.tags != null && tr.tags.length > 0
                    // && this.filterRulesTag.tags2Filter.includes(tr.tag.slug)
                ) {
                  let self = this
                  let tagFound = false
                  tr.tags.forEach(function (tag) {
                    // console.debug(' le tr contien le tag '+tag.slug)
                    if (self.filterRulesTag.tags2Filter.includes(tag.slug)) {
                      console.debug('👻 le tr "' + tr.taskName + '| ' + tr.slug + '" match le filtre tag pour ' + tag.name)
                      tagFound =true
                    } else {
                      // console.warn('💠 le tr "' + tr.taskName + '| ' +tr.slug + '" NE match PAS le filtre tag pour '+ tag.name)

                    }
                  })

                  if(tagFound){
                    return true
                  }

                }
              }
              else{
                return true // si le filtre n'est pas actif alors on considère que le tr match le filtre
              }

            },

            /*
            Retourne true si le timerecord passé en paramètre satisfait les critères du filtre isBillable
            */
            trMatchBillableFilter(tr) {
                if (this.filterBillableIsActive()) {

                    // cas 1 : billable + non billable (le tr est forcémment inclus)
                    if (this.filterRulesBillable.billableFilter && this.filterRulesBillable.nonBillableFilter) {
                        return true;
                    }

                    // cas 2 : billable
                    else if (this.filterRulesBillable.billableFilter && tr.isBillable) {
                        return true;
                    }
                    // cas 3 : non billable
                    else if (this.filterRulesBillable.nonBillableFilter && tr.isBillable != true) {
                        return true;
                    }

                }
                else{
                    return true // si le filtre n'est pas actif alors on considère que le tr match le filtre
                }
            },

          /*
           Retourne true si le timerecord passé en paramètre satisfait les critères du filtre taskName
          */
          trMatchTaskNameFilter(tr) {

            // Comparaison du taskName filtré avec celui du tr (émulation d'une comparaison LIKE sql)

            if (this.filterTaskNameIsActive()) {

              if (!_.isEmpty(tr.taskName)) {
                // On compare le filtre et le taskName sans tenir compte de la casse donc on créé 2 variables intermédiaires
                let filterLower = this.filterRulesTaskName.description.toLowerCase()
                let trTaskNameLower = tr.taskName.toLowerCase()


                // cas 1 : on filtre sur un taskName spécifique + les tr sans description
                if (! _.isEmpty(this.filterRulesTaskName.description) && trTaskNameLower.indexOf(filterLower  && this.filterRulesTaskName.noRelated ) > -1) {

                  return true;
                }
                // cas 2 : on filtre sur un taskName spécifique
                else if (!_.isEmpty(this.filterRulesTaskName.description)
                    && trTaskNameLower.indexOf(filterLower) > -1 // inspriré de https://stackoverflow.com/a/1315242/666416
                ) {
                  return true;
                }

              }
              else{
               if (this.filterRulesTaskName.noRelated && _.isEmpty(tr.taskName)) {
                  return true;
                }
              }

              // cas 3 : tr sans taskname uniquement (pour le moment non inplementé @todo voir https://gitlab.com/ousmane1/kronocloud/-/issues/527)
              // else if (this.filterRulesBillable.nonBillableFilter && tr.isBillable != true) {
              // else if (this.filterRulesTaskName.noRelated && _.isEmpty(tr.taskName)) {
              //   return true;
              // }

            }
            else{
              return true // si le filtre n'est pas actif alors on considère que le tr match le filtre
            }
          }

            /*
                Filtre les timerecords
                Le filtre fonctionne en additionant les critères des filtres. Pour être inclus un timerecord doit satisfaire TOUS les critères des filtres.
             */
            ,filterTimerecords(){

            if (this.filterClientIsActive() || this.filterProjectIsActive() || this.filterBillableIsActive()  || this.filterTaskNameIsActive() || this.filterTagIsActive()
                ){
                    // on crée un nouvel objet qui contiendra les résultats filtrés
                    let resultFiltered = {}

                    let self = this;
                    // on itère sur les tr de la période (groupés dans des clés par jours)
                  _.forOwn(this.timerecordsOfPeriod[this.periodName], function (value, key) { // value est un array de tr

                    let filteredTimerecords = _.filter(value, function (tr) {

                      if (
                          self.trMatchClientFilter(tr) === true
                          &&
                          self.trMatchProjectFilter(tr) === true
                          &&
                          self.trMatchTagFilter(tr) === true
                          &&
                          self.trMatchBillableFilter(tr) === true
                          &&
                          self.trMatchTaskNameFilter(tr) === true

                      ) {
                        return true
                      }

                    });

                    resultFiltered[key] = filteredTimerecords
                  });


                    this.timerecordsOfPeriodFiltered[this.periodName] = resultFiltered
                }
                else{ //bypass du filtrage si le filtre est désactivé
                    this.timerecordsOfPeriodFiltered[this.periodName] = _.clone(this.timerecordsOfPeriod[this.periodName])

                }

            },

            /*
               Initialise les réglages des filtres dans le filterRules dans le store en fonction de la config dans l'url.
               Permet de définir les critères de tri au chargement de la view.
             */
            initFilterRules() {

                // project filter
                this.$store.commit('UpdateReportsViewFilterRulesProject', {
                    noRelated: (this.$route.query.pjctNoRel =='1') ? true : false,
                    projects2Filter: _.values(this.$qs.parse(this.$route.query.pjctProjects)) //  ! il faut convertir l'objet en tableau !
                });

                // client filter
                this.$store.commit('UpdateReportsViewFilterRulesClient', {
                    noRelated: (this.$route.query.cltNoRel =='1') ? true : false,
                    clients2Filter: _.values(this.$qs.parse(this.$route.query.cltClients)) //  ! il faut convertir l'objet en tableau !
                });


                // billable filter
                let billableFilter = false; let nonBillableFilter = false;
                switch (this.$route.query.billable) {
                    case  'all': billableFilter = true; nonBillableFilter = true ; break;
                    case  'billable':billableFilter = true; nonBillableFilter = false; break;
                    case  'nonB':billableFilter = false; nonBillableFilter = true ; break;
                }
                this.$store.commit('UpdateReportsViewFilterRulesBillable', {
                    billableFilter: billableFilter,
                    nonBillableFilter: nonBillableFilter,
                });

              // tasknName filter
              this.$store.commit('UpdateReportsViewFilterRulesTaskName', {
                noRelated: (this.$route.query.taskNameNoRel =='1') ? true : false,
                taskName: this.$qs.parse(this.$route.query.taskNameFilter)
              });

              // tag filter
              this.$store.commit('UpdateReportsViewFilterRulesTag', {
                noRelated: (this.$route.query.tagNoRel =='1') ? true : false,
                tags2Filter: _.values(this.$qs.parse(this.$route.query.tagTags)) //  ! il faut convertir l'objet en tableau !
              });

            },

            /*
               Génère un rapport Pdf du BarChartComp.
               Le fichier est directement proposé au téléchargement.
               Utilise jspdf et dom-to-image | inspiré de : https://stackoverflow.com/questions/47668546/generate-pdf-with-jspdf-and-vue-js
             */
          generatePdf(){
            let l10nDatas={
              paperFormat: 'a4',
              imgWidth: 257, // valeur trouvée "à tâton" //@todo voir dimension localisation letter
              imgHeight: 150 //valeur trouvée "à tâton" //@todo voir dimension localisation letter
            }

            // création du nom du fichier
            let filename
            if (this.periodStartDate == this.periodEndDate) {
              filename = 'Cronocloud '+ this.$t("rapportDactivitéDuX", {dateDebut: this.$moment(this.periodStartDate).format('LL')});

            } else {
              filename = 'Cronocloud '+ this.$t("rapportDactivitéDuXauX", {
                dateDebut: this.$moment(this.periodStartDate).format('LL'),
                dateFin: this.$moment(this.periodEndDate).format('LL')
              });
            }

            let self = this
            this.$domtoimage
                // création d'une image du graphique
                .toJpeg(this.$refs.summaryReport2Print)
                .then(function(dataUrl) {
                  self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                  var img = new Image();
                  img.src = dataUrl;

                  const doc = new self.$jsPDF({
                    orientation: "landscape",
                    unit: "mm",
                    format: l10nDatas.paperFormat // @todo localiser letter
                  });

                  // Ajout de l'image dans le document pdf
                  doc.addImage(img, "JPEG", 20, 20
                      ,l10nDatas.imgWidth
                      ,l10nDatas.imgHeight,
                      null,
                      'NONE'
                  );
                  // téléchargemnt du pdf
                  doc.save(filename);

                  // tracking
                  self.ga4GlobalEventTrack('Report generated' , {"period":self.periodName})
                  self.$mixpanel.track("Pdf report generation", {"period":self.periodName})
                })
                .catch(function(error) {
                  let errorCode = '0036'
                  self.showGlobalErrorNotif(self,errorCode)
                  self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error generating report : "+ error})
                  self.$gtag.exception({'description': 'error '+errorCode + ' | error generating report', 'fatal': false})

                  self.$sentry.captureMessage(`Error ${errorCode} > error generating report : ${error}`, 'error')
                });

          },

          /**
           * Ajoute les paramètres facultatifs à la route actuelle
           * Permet d'éviter à avoir à formatter plus simplement les liens pointant la page rapport  (y compris en dehors de l'app, mautic, backend)
           *
           * @return resolve, reject
           */
          completeRoute(){

            let self = this
              return new Promise((resolve, reject) => {

                //1. si startDate/endDate sont absents dans la route on génère les dates de la période par défaut : cette semaine
                if (_.isEmpty(self.$route.params.startDate) || _.isEmpty(self.$route.params.endDate)) {
                  self.$router.replace({
                    query: {
                      ...self.$route.query,
                    },
                    params: {
                      startDate: self.$moment().startOf('week').format('YYYY-MM-DD'),
                      endDate: self.$moment().endOf('week').format('YYYY-MM-DD')
                    }
                  })
                }

                // 2. vérifications des tous les paramètres
                if(!_.isEmpty(self.$route.params.startDate && !_.isEmpty(self.$route.params.endDate))){
                   resolve('route completed')
                }
                else{
                   reject('query string missins in route')
                }
              });
          }
        },

        created: function () {
        },
        mounted() {


          let self = this

          const promise = this.completeRoute();
          promise
              .then(function (res) {
                // la modification des parm d'url entraine le load des tr via le watch
              })
              .catch(function (err) {
                self.getPeriodTimerecords()
              })


          // On log le dataEVent pour la consultation du rapport au bout de 8 sec.
          setTimeout(function () {
            this.logDataEvent(self, 'REPORT-VIEW-DISPLAYED', null, false)
          }.bind(this), 8000) //binder this est la bonne facon de faire un setTimeout en vue js voir https://stackoverflow.com/a/37465914/666416 @todo refactorer les autres endroits où setTimeout est mal utilisé.

        }


    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/
  @import "../assets/css/globalVar.scss";

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  .darkMode {

    // note je n'ai pas réussi à styliser les onglets dans leurs composants mais seulement ici
    .tabs {

      &.is-boxed{
        .is-active{
          a{
            color:$darkContrastTxt !important;
            border-color:lighten($darkBg, 10%) ;
            border-bottom-color: transparent ;
            background-color: $darkBg2 !important;
            &:hover{
              border-color:lighten($darkBg, 10%) ;
            }
          }
        }
      }
      ul{
        border-bottom-color:lighten($darkBg, 10%) ;
      }
      li {
        a{
          color: $darkLightBlue;
          background-color: transparent;
          &:hover{
            background-color: transparent;
            border-bottom-color: transparent ;
            color:$darkLightBlue;
          }
        }
        &.is-active{
          a{
            color:$darkLightBlue !important;
            background-color: $darkBg2 ;
          }

        }
      }
    }


  }

</style>

<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

#ReportsView {
  .headerZone {
  }

  .columnTypeSelector {
    /*border: dashed 1px gold;*/
    padding-top: 0;
    @include mobile{
      margin-top: .8rem;
    }
  }

  .columnBtn {
    padding: 0;

    .buttonsColumn {
      padding: 0;

      #DownloadReportBtn {
        margin-bottom: 0;
        @include mobile {
          padding: 2rem 1rem 2rem 1.6rem;
        }

      }
    }
  }

  .filterZone {
    padding: 1.2rem;
    background: #e8e8e8;

    .periodSelectorCont {
      z-index: 1; // évite que le contenu des TimerecordReportTableLineComp ne passe pas par dessus .selector
    }

  }

  .chartZone {
    margin: 1rem 0;
    background: white;
    border-radius: 2px;
    padding: 1rem;
  }


  #hiddenChartData{
    &:before{content: "️️Hidden chart Data, uniqeument visible en Dev"; background: $brandBlue; padding: .2rem; color: #333; margin-bottom: .4rem; font-weight: bold; display: block}
    background-color: darken($darkBg3,5%);
    margin-top: 3rem;
    border: dashed 1px #666;
    text-align: left;
    font-size: .9rem;
    font-family: Courier Next, courier, monospace;
    padding: .4rem;
    .groupDay{
      margin-bottom: 1rem;
      border-bottom: dashed 1px #666;
      padding-bottom: .3rem;
      .date{font-weight: bold; color: #888}
      .trDetails{
        color: #888;
        margin-bottom: .3rem;
        .taskName{
          background-color: $darkBg2; color: #ccc; padding: 3px 5px;
          border-radius: 2px;
        }
      }
    }
    span{
      margin: 0 .3rem 0;
    }
  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {


    .filterZone{
      background-color: $darkBg3;
    }
    .chartZone {
      background:$darkBg3;
      color:$darkTxt;
    }

    #hiddenChartData{
      color: $darkTxt;
    }
  }
}
</style>
